import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Slider from "react-slick";
import { getAllPluginsByUuId } from "../../redux/modules/plugins";
import { Loader, Container } from 'semantic-ui-react';
import { updateVideoViewCount } from "../../redux/modules/video";
import commonHelper from '../../helpers/commonHelper';
import { config } from "../../config";
import { Button, Card, EmbeddedLogo } from '../../components';
import "./style.css";

class Plugin extends Component {
  state = {
    videos: [],
    loading: false,
    showPreviusButton: false,
  };

  static propTypes = {
    dispatch: PropTypes.func,
    list: PropTypes.array
  };

  viewCount = async id => {
    await this.props.dispatch(updateVideoViewCount(id));
  };

  componentWillMount = async () => {
    document.body.style.backgroundColor = "transparent";
    window.addEventListener('resize', this.onResizePage);
  }

  componentDidMount = async () => {
    const { dispatch, match } = this.props;
    const { uuid } = match.params;

    const res = commonHelper.getQueryParams(this.props.location.search);
    const { custid, tag } = res;
    this.setState({ loading: true });
    dispatch(getAllPluginsByUuId(uuid, custid, tag))
      .then(async (result) => {
        result && result.videos.length > 0
          ? await this.processData()
          : this.setState({ loading: false });
      });
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResizePage);
  }

  onResizePage = () => {
    this.forceUpdate();
  }

  getThumbnail = video =>
    new Promise(async resolve => {
      const siteAssets = config.AWS.SiteAssets;
      const { thumbFileType, thumbFileName, id, videoId, fileName, isVideoEdited, thumbnailPath } = video;
      const baseURL = `${siteAssets}/video/thumbnail`;
      // this is the thumbnail an admin can upload to override the one that is generated during video processing
      const original = `${baseURL}/original/${id}/${thumbFileName}.${thumbFileType}`;
      const editedVideoThumbnail = `${siteAssets}/${videoId}/${fileName}.0000000.jpg`;
      const defaultThumbnail = `${siteAssets}/${videoId}/${fileName}-00001.jpg`;
      const v2Edited = (thumbnailPath && thumbnailPath.startsWith('assets/'));

      if(v2Edited) {
        resolve(`${siteAssets}/${thumbnailPath}`);
      }
      if (thumbFileName && thumbFileType) {
        return resolve(original);
      }
      if (isVideoEdited) {
        return resolve(editedVideoThumbnail);
      }
      resolve(defaultThumbnail);
    });

  processData = () => {
    const videos = this.props.list.videos.map(async (video, idx) => {
      const thumbnail = await this.getThumbnail(video);
      return <Card
        thumbSRC={thumbnail}
        video={video}
        index={idx}
        onThumbnailClick={() => this.viewCount(video.id)}
      />
    });

    Promise.all(videos).then(completed => {
      this.setState({ videos: completed, loading: false });
    });
  }

  isResponsive = maxSize => window.innerWidth <= maxSize;

  getSlidesSettings = amountVideos => {
    if (this.isResponsive(425)) return 1;
    if (this.isResponsive(991) && amountVideos) return 2;
    return amountVideos >= 2 ? 3 : 1;
  }

  enableInfinite = amountVideos =>
    (this.isResponsive(425) && amountVideos > 1) || amountVideos > 3;

  render() {
    const { showVideoPeelLogo } = this.props.list;
    const { videos, loading, showPreviusButton } = this.state;
    const haveMoreTwoVideos = videos.length > 2;
    const haveOneVideo = videos.length === 1;
    const slidesToShow = this.getSlidesSettings(videos.length);

    return (
      <Container className="mainSlider">
        {loading && <Loader />}
        {
          videos && videos.length > 0 && (
            <div>
              <Slider
                className={
                  `${!haveMoreTwoVideos && 'center-content'} ${haveOneVideo && 'one-video'}`
                }
                dots={false}
                slidesToShow={slidesToShow}
                slidesToScroll={slidesToShow}
                prevArrow={
                  <Button
                    direction="left"
                    show={showPreviusButton}
                  />
                }
                nextArrow={
                  <Button
                    show
                    direction="right"
                    handleClick={() => {
                      if (!this.state.disablePreviusButton) {
                        this.setState({ showPreviusButton: true });
                      }
                    }}
                  />
                }
                vertical={false}
                infinite={this.enableInfinite(videos.length)}
                lazyLoad={videos.length > 3}
              >
                {videos.map(Item => Item)}
              </Slider>

              <EmbeddedLogo
                show={showVideoPeelLogo}
                className={haveMoreTwoVideos ? '' : 'center-logo'}
              />
            </div>
          )
        }
      </Container>
    );
  }
}

export default connect(state => ({
  list: state.get('plugins').get('list')
}))(Plugin);



// WEBPACK FOOTER //
// ./src/containers/Plugin/Plugin.js